import { get } from './requests'

export const searchSuggestions = key => payload =>
  get(['users', 'suggestion'], { key, params: { search: payload } })
